import {
  type IMCAttributionWindowDays,
  type INBAccountingMode,
} from "@north-beam/nb-common";

import { type SalesMetricV2 } from "../types";

export function makeVisitors({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "visitors";

  return {
    id,
    name: "Users",
    fullName:
      "Users / All" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description: "Unique users to your website",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}

export function makeVisitorsFt({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "visitorsFt";

  return {
    id,
    name: "Users (New)",
    fullName:
      "Users / New" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description: "Unique new users to your website",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}

export function makeVisitorsRtn({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "visitorsRtn";

  return {
    id,
    name: "Users (Returning)",
    fullName:
      "Users / Ret" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description: "Unique returning users to your website",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}

export function makeVisitorsFtRtn({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "visitorsFtRtn";

  return {
    id,
    name: "Users (New Returning)",
    fullName:
      "Users / New Returning" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description: "Unique new returning users to your website",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}
